export default __webpack_public_path__ + "static/media/Captain's Gauntlets of Dynastic Rule.d7051ad3.jpg";